import home from './home';

let messages = Object.assign({}, home);

export default messages;
